/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteMcpUpdateServer } from "../funcs/remoteMcpUpdateServer.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RemoteMcpServer } from "../models/components/remotemcpserver.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateRemoteMcpServerRequest,
  UpdateRemoteMcpServerSecurity,
} from "../models/operations/updateremotemcpserver.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpdateRemoteMcpServerMutationVariables = {
  request: UpdateRemoteMcpServerRequest;
  security?: UpdateRemoteMcpServerSecurity | undefined;
  options?: RequestOptions;
};

export type UpdateRemoteMcpServerMutationData = RemoteMcpServer;

export type UpdateRemoteMcpServerMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateServer remoteMcp
 *
 * @remarks
 * Update a remote MCP server
 */
export function useUpdateRemoteMcpServerMutation(
  options?: MutationHookOptions<
    UpdateRemoteMcpServerMutationData,
    UpdateRemoteMcpServerMutationError,
    UpdateRemoteMcpServerMutationVariables
  >,
): UseMutationResult<
  UpdateRemoteMcpServerMutationData,
  UpdateRemoteMcpServerMutationError,
  UpdateRemoteMcpServerMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpdateRemoteMcpServerMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpdateRemoteMcpServer(): MutationKey {
  return ["@gram/client", "remoteMcp", "updateServer"];
}

export function buildUpdateRemoteMcpServerMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpdateRemoteMcpServerMutationVariables,
  ) => Promise<UpdateRemoteMcpServerMutationData>;
} {
  return {
    mutationKey: mutationKeyUpdateRemoteMcpServer(),
    mutationFn: function updateRemoteMcpServerMutationFn({
      request,
      security,
      options,
    }): Promise<UpdateRemoteMcpServerMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(remoteMcpUpdateServer(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
